import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import back from "../../asset/landing_images/landing-building.webp";
import backMobile from "../../asset/landing_images/landing-small2.webp"; // Mobile background image

const LandingBuilding = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
  });

  const isMobile = window.innerWidth <= 767;
  const isTablet = window.innerWidth > 767 && window.innerWidth <= 1024;

  // Animation for the entire div
  const slideUpAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(50px)",
    config: { tension: 60, friction: 30, duration: 1000 },
  });

  // Animation for the text
  const textAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateX(0)" : "translateX(-30px)",
    config: { tension: 60, friction: 30, duration: 1000 },
  });

  // Background style for the section
  const handSectionStyle = {
    height: "100%",
    backgroundImage: `url(${isMobile ? backMobile : back})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    paddingTop: isMobile ? "5rem" : "0",
  };

  const textContainerStyle = {
    paddingTop: isMobile ? "2rem" : "8rem",
    display: "flex",
    flexDirection: "column",
    
    marginLeft: isMobile ? '1rem' : isTablet ? '18rem' : "40rem",
    marginTop: isMobile ? "6rem" : 0,
    marginRight: isMobile ? "1rem" : "0",
    textAlign: "center",
    // border:'2px solid red'
  };

  return (
    <animated.div
      style={{ height: "40rem", marginTop: "5rem", ...slideUpAnimation }}
      ref={ref}
    >
      <div style={handSectionStyle}>
        <animated.div style={{ ...textContainerStyle, ...textAnimation }}>
          <h2
            style={{
              fontWeight: "bold",
              color: "#fff",
              fontSize: isMobile ? "2.5rem" : "3rem",
            }}
          >
            Your Digital Social Hub
          </h2>
          <p style={{ fontWeight: "100", color: "#fff" }}>
            Post updates, upload photos, and create events or polls. <br />
            Engage with friends through comments, likes, and shares.
            <br />
            React to posts with a variety of emotions: love, laugh, wow, and
            more.
          </p>
        </animated.div>
      </div>
    </animated.div>
  );
};

export default LandingBuilding;
